async function redirect({ payload }, context) {
  // if (context.history.location.pathname == payload.path) return;
  // return context.history.push(payload.path)

  window.location = window.location.origin + window.location.pathname + "#" + payload.path;
}

export default {
  redirect
}